export enum BetStartAttribute {
  Master = 838,
}
